import {
  initialState,
  Actions,
  State,
  UPDATE_MODULE,
  UPDATE_MODULE_SUCCESS,
  UPDATE_MODULE_ERROR,
  RESET_UPDATE_MODULE,
} from "../../types/module/update-module";

const reducers = (state = initialState, action: Actions): State => {
  switch (action.type) {
    case UPDATE_MODULE:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: false,
          success: false,
        },
      };
    case UPDATE_MODULE_SUCCESS:
      return {
        ...state,
        data: action.payload,
        states: {
          loading: false,
          error: false,
          success: true,
        },
      };
    case UPDATE_MODULE_ERROR:
      return {
        ...state,
        data: null,
        states: {
          loading: false,
          error: action.payload,
          success: false,
        },
      };
    case RESET_UPDATE_MODULE:
      return initialState;
    default:
      return state;
  }
};

export default reducers;
